import axios from "axios";

export const INSTAPAY_ENROLL_REQUEST = "INSTAPAY_ENROLL_REQUEST";
export const INSTAPAY_ENROLL_SUCCESS = "INSTAPAY_ENROLL_SUCCESS";
export const INSTAPAY_ENROLL_FAILURE = "INSTAPAY_ENROLL_FAILURE";

export const CREATE_PAYMENT_CHECKOUT_REQUEST = "CREATE_PAYMENT_CHECKOUT_REQUEST";
export const CREATE_PAYMENT_CHECKOUT_SUCCESS = "CREATE_PAYMENT_CHECKOUT_SUCCESS";
export const CREATE_PAYMENT_CHECKOUT_FAILURE = "CREATE_PAYMENT_CHECKOUT_FAILURE";
export const CREATE_BANK_TRANSFER_REQUEST = "CREATE_BANK_TRANSFER_REQUEST";
export const CREATE_BANK_TRANSFER_SUCCESS = "CREATE_BANK_TRANSFER_SUCCESS";
export const CREATE_BANK_TRANSFER_FAILURE = "CREATE_BANK_TRANSFER_FAILURE";
export const UPLOAD_BANK_TRANSFER_RECEIPT_REQUEST = "UPLOAD_BANK_TRANSFER_RECEIPT_REQUEST";
export const UPLOAD_BANK_TRANSFER_RECEIPT_SUCCESS = "UPLOAD_BANK_TRANSFER_RECEIPT_SUCCESS";
export const UPLOAD_BANK_TRANSFER_RECEIPT_FAILURE = "UPLOAD_BANK_TRANSFER_RECEIPT_FAILURE";

export const APPLY_COUPON_REQUEST = "APPLY_COUPON_REQUEST";
export const APPLY_COUPON_SUCCESS = "APPLY_COUPON_SUCCESS";
export const APPLY_COUPON_FAILURE = "APPLY_COUPON_FAILURE";

export const instaPayEnrollAction = (teacherCourseId, code, termsAcceptance, paymentMethod = "instaPay") => async (dispatch) => {
  dispatch({ type: INSTAPAY_ENROLL_REQUEST, teacherCourseId });

  try {
    // 👇 build the URL once — code is optional
    const url = `${process.env.REACT_APP_API_URL}/api/students/request/${teacherCourseId}/student-courses`;
    
    // 👇 pass code only if it exists
    const response = await axios.post(url, { termsAcceptance, paymentMethod }, {
      params: code && code.trim() !== "" ? { code } : {},
    });

    dispatch({
      type: INSTAPAY_ENROLL_SUCCESS,
      teacherCourseId,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: INSTAPAY_ENROLL_FAILURE,
      teacherCourseId,
      payload: error.response?.data?.message || "Booking failed",
    });
  }
};

export const createPaymentCheckoutAction = (teacherCourseId, provider, code, termsAcceptance, forceNew = false) => async (dispatch) => {
  dispatch({ type: CREATE_PAYMENT_CHECKOUT_REQUEST, teacherCourseId });
  const checkoutWindow = window.open("about:blank", "_blank");

  if (checkoutWindow) {
    checkoutWindow.opener = null;
    checkoutWindow.document.title = "Opening checkout...";
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/payments/checkout`,
      {
        provider,
        teacherCourseId,
        couponCode: code && code.trim() !== "" ? code.trim() : null,
        termsAcceptance,
        forceNew,
      }
    );

    dispatch({
      type: CREATE_PAYMENT_CHECKOUT_SUCCESS,
      teacherCourseId,
      payload: response.data,
    });

    if (response.data?.existingPending) {
      if (checkoutWindow && !checkoutWindow.closed) {
        checkoutWindow.close();
      }
    } else if (response.data?.checkoutUrl) {
      if (checkoutWindow && !checkoutWindow.closed) {
        checkoutWindow.location.href = response.data.checkoutUrl;
      } else {
        window.open(response.data.checkoutUrl, "_blank", "noopener,noreferrer");
      }
    }
  } catch (error) {
    if (checkoutWindow && !checkoutWindow.closed) {
      checkoutWindow.close();
    }

    dispatch({
      type: CREATE_PAYMENT_CHECKOUT_FAILURE,
      teacherCourseId,
      payload:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Could not start online payment",
    });
  }
};

export const createBankTransferPaymentAction = (teacherCourseId, transferType, code, termsAcceptance) => async (dispatch) => {
  dispatch({ type: CREATE_BANK_TRANSFER_REQUEST, teacherCourseId });

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/payments/bank-transfer`,
      {
        teacherCourseId,
        transferType,
        couponCode: code && code.trim() !== "" ? code.trim() : null,
        termsAcceptance,
      }
    );

    dispatch({
      type: CREATE_BANK_TRANSFER_SUCCESS,
      teacherCourseId,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_BANK_TRANSFER_FAILURE,
      teacherCourseId,
      payload:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Could not create bank transfer payment",
    });
  }
};

export const uploadBankTransferReceiptAction = (teacherCourseId, transactionId, file) => async (dispatch) => {
  dispatch({ type: UPLOAD_BANK_TRANSFER_RECEIPT_REQUEST, teacherCourseId });

  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/payments/bank-transfer/${transactionId}/receipt`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    dispatch({
      type: UPLOAD_BANK_TRANSFER_RECEIPT_SUCCESS,
      teacherCourseId,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: UPLOAD_BANK_TRANSFER_RECEIPT_FAILURE,
      teacherCourseId,
      payload:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Could not upload transfer receipt",
    });
  }
};


export const applyCouponAction = (teacherCourseId, code) => async (dispatch) => {
  dispatch({ type: APPLY_COUPON_REQUEST, teacherCourseId });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/students/coupon/apply/${teacherCourseId}?code=${encodeURIComponent(code)}`
    );

    dispatch({
      type: APPLY_COUPON_SUCCESS,
      teacherCourseId,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: APPLY_COUPON_FAILURE,
      teacherCourseId,
      payload: error.response?.data?.message || "Invalid or expired coupon code",
    });
  }
};

export const instaPayEnrollActionForFullCourse = (teacherCourseId,parentCourseId, code, termsAcceptance, paymentMethod = "instaPay") => async (dispatch) => {
  dispatch({ type: INSTAPAY_ENROLL_REQUEST, parentCourseId });

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/students/request/complete/${teacherCourseId}/${parentCourseId}/student-courses`,
      { termsAcceptance, paymentMethod },
      { params: code ? { code } : {} }
    );

    dispatch({
      type: INSTAPAY_ENROLL_SUCCESS,
      parentCourseId,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: INSTAPAY_ENROLL_FAILURE,
      parentCourseId,
      payload: error.response?.data?.message || "Booking full course failed",
    });
  }
};

// 🔸 Apply coupon for a full course (A1 = parent course)
export const applyCouponActionForFullCourse = (parentCourseId, code) => async (dispatch) => {
  dispatch({ type: APPLY_COUPON_REQUEST, parentCourseId });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/students/coupon/apply/full/${parentCourseId}?code=${encodeURIComponent(code)}`
    );

    dispatch({
      type: APPLY_COUPON_SUCCESS,
      parentCourseId,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: APPLY_COUPON_FAILURE,
      parentCourseId,
      payload: error.response?.data?.message || "Invalid or expired coupon code",
    });
  }
};
